export enum TokenTypeEnum {
    DEFAULT = 'DEFAULT',
    ICE_DASHBOARD = 'ICE_DASHBOARD',
    IDENTITY_TOKEN = 'IDENTITY_TOKEN',
}
